<script setup lang="ts">
import BravoProgressSpinner from '@services/ui-component-library/components/BravoProgressSpinner.vue'
</script>

<template>
  <div class="sso-completing-indicator" data-testid="sso-completing-indicator">
    <BravoProgressSpinner
      data-testid="sso-completing-spinner"
      class="sso-completing-spinner"
      strokeWidth="4"
      animationDuration="1.5s"
    />
    <div class="sso-completing-text" data-testid="sso-completing-message">
      Please wait while the login process completes
    </div>
  </div>
</template>

<style scoped>
.sso-completing-indicator {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
}

.sso-completing-spinner {
  width: 50px;
  height: 50px;
}

.sso-completing-text {
  color: var(--color-text, #333333);
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  max-width: 300px;
}
</style>
